import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { __ADMIN__ } from '@vz/env';
import { Helmet } from 'react-helmet-async';

import window from 'window-or-global';

import { useSWR } from '../../hooks/useSWR';

import Spinner from '../../components/Spinner';

import { CodeDemo } from '../../components/CodeDemo';
import { NotFoundPage } from '../lazy';

const spinnerStyle = { top: 'calc(50% - 12px)' };

const Demo = () => {
  const { url } = useParams();
  const {
    data: apiResponse,
    error,
    isLoading
  } = useSWR(`/api/demo/${url}`, {
    initial: window.__INITIAL_DATA__?.[`/api/demo/${url}`]
  });

  const data = apiResponse?.data;

  if (isLoading && !data) {
    return <Spinner size={24} style={spinnerStyle} />;
  }

  if (error) {
    return <NotFoundPage />;
  }

  // const content = apiResponse?.data || data;
  if (!data) {
    return <NotFoundPage />; // TODO: NOT FOUND
  }

  return (
    <>
      <Helmet>
        <title>{data.title}</title>
        <meta
          property="og:image"
          content={`https://www.zubach.com/api/img/demos/${url}/index.png`}
        />
        {/* <link rel="canonical" href="https://www.tacobell.com/" /> */}
      </Helmet>
      <CodeDemo data={data} />
    </>
  );
};

export default Demo;
